'use client'

import {useState} from 'react'
import {Button} from '@/components/ui/button'
import {FormattedMessage} from 'react-intl'

const INITIAL_VISIBLE = 8

export type TechSpecRow = {
  key: string
  label: string
  value: string
}

export function TechSpecsList({rows}: {rows: TechSpecRow[]}) {
  const [expanded, setExpanded] = useState(false)
  const showToggle = rows.length > INITIAL_VISIBLE
  const visible = expanded || !showToggle ? rows : rows.slice(0, INITIAL_VISIBLE)

  return (
    <>
      <dl className="space-y-site-sm">
        {visible.map((row) => (
          <div
            key={row.key}
            className="flex items-start justify-between gap-site-sm border-b border-border pb-site-sm last:border-b-0 last:pb-0 u-body-sm"
          >
            <dt className="text-muted-foreground">{row.label}</dt>
            <dd className="text-right font-medium text-foreground">{row.value}</dd>
          </div>
        ))}
      </dl>
      {showToggle ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="mt-site-sm u-body-sm font-semibold"
          aria-expanded={expanded}
          onClick={() => setExpanded((value) => !value)}
        >
          {expanded ? (
            <FormattedMessage id="product.readLess" defaultMessage="Read less" />
          ) : (
            <FormattedMessage id="product.readMore" defaultMessage="Read more" />
          )}
        </Button>
      ) : null}
    </>
  )
}
